import { PcsDndConfig } from './dnd-config';

export class DefaultConfig implements PcsDndConfig {
  dragOverClass = 'dnd-dragover';
  droppableDisabledClass = 'dnd-droppable-disabled';
  draggingSourceClass = 'dnd-dragging-source';
  draggableDisabledClass = 'dnd-draggable-disabled';
  droppableClass = 'dnd-droppable-area';
}
